import React from 'react'
import { motion } from 'framer-motion' 


const sectionVariant = {
    visible: {
      opacity: 1,
      transition: { ease: "easeOut", duration: 0.4, delay: 0.1 },
    },
    leave: {
      opacity: 0,
      transition: { ease: "easeIn", duration: 0.2 },
    },
};

const titleVariant = {
    visible: {
      y: 0,
      transition: { ease: "easeOut", duration: 0.4, delay: 0.1 },
    },
    leave: {
      y: 20,
      transition: { ease: "easeIn", duration: 0.2 },
    },
};



const Section5 = ({ isActive }) => {
  return (  
    <motion.div variants={sectionVariant}
        initial={false}
        animate={isActive ? "visible" : "leave"} className="mb-5 pe-lg-5 text1  py-lg-2 py-xxl-5">
            <motion.h5 
                variants={titleVariant}
                className='mb-3'>
                    Quiz & Performance Analysis
            </motion.h5>
            <motion.p   
                variants={titleVariant}
                className='col-lg-9'>
                    Assess your knowledge with our topic-related quizzes at the end of each lesson. Consolidate your strengths and get tips for necessary improvement.
            </motion.p>
    </motion.div>
  )
}

export default Section5